import { css } from 'lit';

export const serverPageStyles = css`
  .networks {
    display: grid;
    gap: var(--space-2);
    max-width: var(--form-width-sm);
  }

  .networks p {
    margin: 0;
  }

  .networks button {
    justify-self: start;
  }
`;
